<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'Jobs'}"
            class="btn btn-primary btn-round">
          back
        </b-link>
      </template>
    </navbar>

    <b-card>
      <b-form-group
          class="required"
          :state="!validation.hasError('title')"
          :invalid-feedback="validation.errorTitle('title')"
          label="Title">
        <b-input v-model="form.title"></b-input>
      </b-form-group>

      <b-form-group
          class="required"
          :state="!validation.hasError('caption')"
          :invalid-feedback="validation.errorTitle('caption')"
          label="Caption">
        <tinymce id="d1" v-model="form.caption"></tinymce>
      </b-form-group>

      <b-form-group
          class="required"
          :state="!validation.hasError('form_title')"
          :invalid-feedback="validation.errorTitle('form_title')"
          label="Form Title">
        <tinymce id="d2" v-model="form.form_title"></tinymce>
      </b-form-group>

      <b-form-group
          class="required"
          :state="!validation.hasError('description')"
          :invalid-feedback="validation.errorTitle('description')"
          label="Description">
        <tinymce id="d3"
                 v-model="form.description"></tinymce>
      </b-form-group>


      <b-form-group
          label="Options">
        <b-form-checkbox v-model="form.is_deactive">is Deactivate?</b-form-checkbox>
        <b-form-checkbox v-model="form.is_hide">is Hide?</b-form-checkbox>
        <b-form-checkbox v-model="form.is_branch_form">is franchise form?</b-form-checkbox>
        <b-form-checkbox v-model="form.is_company_required">is required company name?</b-form-checkbox>

      </b-form-group>


      <template v-if="isEdit">
        <b-button variant="success" @click="updateJob">{{ $t('saveTitle') }}</b-button>
      </template>
      <template v-else>
        <b-button variant="success" @click="storeJob">{{ $t('saveTitle') }}</b-button>
      </template>
    </b-card>


    <!--START Items-->
    <template v-if="jobs.length > 0">
      <draggable v-model="jobs" group="jobs"
                 @update="updateOrder"
                 @start="drag=true"
                 handle=".handle"
                 @end="drag=false">
        <div v-for="(item,index) in jobs" :key="index">
          <b-card :title="item.title">

            <b-list-group>
              <b-list-group-item>
                <span>is deactive?</span>
                <span class="ml-4">{{item.is_deactive}}</span>
              </b-list-group-item>
              <b-list-group-item>
                <span>is hide?</span>
                <span class="ml-4">{{item.is_hide}}</span>
              </b-list-group-item>
              <b-list-group-item>
                <span>is franchise form?</span>
                <span class="ml-4">{{item.is_branch_form}}</span>
              </b-list-group-item>
            </b-list-group>

            <b-button variant="info" @click="editItem(item)">edit</b-button>
            <b-button variant="danger" @click="deleteJob(item.id)">delete</b-button>

            <span class="ml-3 handle">
              <span class="material-icons">drag_handle</span>
            </span>
          </b-card>
        </div>
      </draggable>

    </template>
    <!--END Items-->

  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import Validation from '../../Services/Validation/Validation'
import Notificaion from "../../Services/Notification/Nottification";
import draggable from 'vuedraggable'



export default {
  name: "NewJob",
  components: {Navbar,draggable},
  data() {
    return {
      generateComponent: {
        count: 1
      },

      validation: new Validation(),
      isEdit: false,
      jobId: 0,
      form: {
        title: null,
        description: null,
        caption: null,
        form_title: null,
        is_deactive: false,
        is_hide: false,
        is_branch_form: false,
        is_company_required: false,
      },
      jobs: []
    }
  },
  methods: {
    updateOrder() {
      this.$Progress.start();
      Http.post(Http.apiurl() + 'job/order/items/process', {
        items: this.jobs
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getJobs();
              Notificaion.success(response.data.message)
            } else {
              Notificaion.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    generateGridComponent() {
      this.generateComponent.count++;
    },
    resetForm() {
      this.form.is_branch_form = false;
      this.form.is_hide = false;
      this.form.is_deactive = false;
      this.form.is_company_required = false;
      this.form.title = null;
      this.form.caption = null;
      this.form.form_title = null;
      this.form.description = null;
    },
    editItem(item) {
      window.scrollTo(0, 0);
      this.isEdit = true;
      this.jobId = item.id;
      this.form.title = item.title;
      this.form.form_title = item.form_title;
      this.form.caption = item.caption;
      this.form.description = item.description;
      this.form.is_deactive = (item.is_deactive === 'yes');
      this.form.is_hide = (item.is_hide === 'yes');
      this.form.is_branch_form = (item.is_branch_form === 'yes');
      this.form.is_company_required = (item.is_company_required === 'yes');
    },
    storeJob() {
      this.$Progress.start();
      Http.post(Http.apiurl() + 'job/store', this.form)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.created()) {
              this.getJobs();
              this.resetForm();
              Notification.success(response.data.message)

            } else {
              this.validation.store(response.data.data);

              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    updateJob() {
      this.$Progress.start();
      Http.post(Http.apiurl() + 'job/update/' + this.jobId, this.form)
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              //this.isEdit = false;
              //this.resetForm();
              this.getJobs();
              Notification.success(response.data.message)


            } else {
              this.validation.store(response.data.data);
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    getJobs() {
      this.$Progress.start();
      Http.get(Http.apiurl() + 'job/index')
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.jobs = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    deleteJob(id) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurl() + 'job/delete/' + id)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.resetForm();
                this.getJobs();
                Notification.success(response.data.message)

              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  },
  created() {
    this.getJobs();
  }
}
</script>

<style scoped>

</style>